"use strict"
exports.__esModule = true;
exports.StravaIconConfig = {
  name: 'StravaIcon',
  height: 512,
  width: 384,
  svgPath: 'M158.4 0L7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292l-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z',
  yOffset: 0,
  xOffset: 0,
};
exports.StravaIcon = require('../createIcon').createIcon(exports.StravaIconConfig);
exports["default"] = exports.StravaIcon;